export class Gps {
  public latitude: number;
  public longitude: number;
  public alt: number;
  public pre: number;

  public get isValid(): boolean {
    if (isNaN(this.latitude)) {
      return false;
    }
    if (isNaN(this.longitude)) {
      return false;
    }
    if (typeof this.longitude !== 'number') {
      return false;
    }
    if (typeof this.latitude !== 'number') {
      return false;
    }
    return true;
  }

  constructor(latitude: number, longitude: number, alt?: number, pre?: number) {
    this.latitude = latitude;
    this.longitude = longitude;
    if (alt || alt === 0) {
      this.alt = alt;
    }
    if (pre || pre === 0) {
      this.pre = pre;
    }
  }

  toString() {
    return this.isValid
      ? `${Math.round(this.latitude * 100) / 100}, ${Math.round(this.longitude * 100) / 100}`
      : '-';
  }

  generateGoogleLinks() {
    return this.isValid
      ? `https://www.google.com/maps/search/?api=1&query=${this.latitude},${this.longitude}`
      : '';
  }
}
